import '../App.css';
import React from 'react';
import { ActionGroup, Header, Text, Heading, Flex, Divider, Button } from '@adobe/react-spectrum';
import Instructions from '../Instructions';
import ProgressBar from './TestProgressBar';
import { useState } from 'react';
import { useTimer } from 'react-timer-hook';

function MainToolbar({ ...properties }) {
    const {
        seconds,
        minutes,
        hours,
        days,
        totalSeconds,
        isRunning,
        start,
        pause,
        resume,
        restart,
    } = useTimer({ expiryTimestamp: properties.startTime + properties.timeLimit, autoStart: true, onExpire: () => properties.submitForm() });

    return (
        <div className="mainToolbar">
            <Header>
                <Flex direction="row" gap="size-200" height={"size-500"} justifyContent={'left'} >

                    <Heading level={2} width="size-700" marginStart="size-100" marginBottom="size-100" marginTop="size-0">{minutes}:{seconds < 10 ? 0 : null}{seconds}</Heading>
                    <Divider orientation="vertical" height="size-300" marginTop="size-50" size='M' />
                    {
                        properties.experiment === "exp2-highlights" ?

                            <Text marginTop="size-50">Answered {properties.numAnsweredQuestions} of 5 questions.</Text>
                            : <Text marginTop="size-50">Answered {properties.numAnsweredQuestions} of 20 questions.</Text>
                    }

                    <Instructions marginTop="size-50" text={properties.instructions} />

                </Flex>

                <ProgressBar currentTime={totalSeconds} maxTime={properties.timeLimit / 1000} />
            </Header>

        </div>
    );
}

export default MainToolbar;